import React, { useEffect, useState } from "react";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Row,
  Col,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  Divider
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import roleApi from "../../service/roleService";
import locationTourApi from "../../service/locationTourService";
import adminService from "../../service/adminService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "./management.css";
import Map from "../../components/map/Map";
// import MapManagement from "./MapManagement";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Role } from "../../components/shares/roles";

const { Option } = Select;
export default function ManagementPage() {
  const navigate = useNavigate();

  const currentLocation = useSelector((state) => state.currentLocation);

  const [adminId, setAdminId] = useState(0);
  const [currentId, serCurrentId] = useState(0);

  const [isShowUpdateAdmin, setIsShowUpdateAdmin] = useState(false);

  const [listAdmin, setListAdmin] = useState([]);

  const [listRole, setListRole] = useState([]);

  const [dataLocationTour, setDataLocationTour] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileListSubmit, setFileListSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [imagePath, setImagePath] = useState("");

  const [imageUrl, setImageUrl] = useState();


  console.log(currentLocation);
  // const { id } = useParams();
  const [form] = Form.useForm();
  const adminAuthen = useSelector((state) => state.adminAuthen);

  useEffect(() => {    
    const userData = adminAuthen.user 
    console.log(`Admin-Management effect ${JSON.stringify(userData)}`)
    if(userData?.role != Role.SuperAdmin){
      navigate("/management");
    }
    serCurrentId(userData?.id)
    getAllAdmin();
  }, []);

  const getAllAdmin = () => {
    adminService.adminApi.getAllAdmin().then((res) => {
      console.log(`getAllAdmin:  ${JSON.stringify(res)}`)
      if(res) setListAdmin(res.data);      
    });
  };

  const openModalAdmin = (id) => {
    setIsShowUpdateAdmin(true);
    setAdminId(id);
    getRole();
    if (id) {
      adminService.adminApi.getAdminById(id).then((res) => {
        // const pictureFilenameParse = JSON.parse(res.data.pictureFilename);
        // setDataLocationTour({
        //   ...res.data,
        //   pictureFilename: JSON.parse(res.data.pictureFilename),
        // });
        // const files = [];
        // const filesSubmit = [];
        // if (pictureFilenameParse.length > 0) {
        //   pictureFilenameParse.forEach((item) => {
        //     files.push({ url: BASE_URL + item });
        //     filesSubmit.push(item);
        //   });
        // }
        // setFileList(files);
        // setFileListSubmit(filesSubmit);
        console.log(11,res.data);
        setImageUrl(res.data.avatar)
        form.setFieldsValue({
          userName: res.data.userName,
          email: res.data.email,
          roleId: res.data.roleId,
        });
      });
    }
  };
  const onCloseModalAdmin = () => {
    setAdminId(0)
    setIsShowUpdateAdmin(false);
    form.setFieldsValue({
      userName: "",
      email: "",
      password: "",
      confirmPassword: "",
      roleId: 0,
    });
    setImageUrl(null)
  };

  const deleteAdmin = () => {
    adminService.adminApi.deleteAdmin(adminId).then((res) => {
      notification.success({ message: `Delete Admin success` });
      getAllAdmin();
      setOpenDeleteDialog(false);
    });
  };

  const getRole = () => {
    roleApi.getAllRole().then((response) => {
      setListRole(response.data);
      console.log(333, response.data);
      form.setFieldsValue({ roleId: response.data[0].id });
    });
  };

  const layout = {
    labelCol: { span: 8 },
    labelAlign: "left",
    wrapperCol: { span: 16 },
  };
  const columnsTour = [
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Quyền",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
          disabled={_.id===currentId}
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalAdmin(_.id)}
          >
            Sửa
          </Button>
          <Button
          disabled={_.id===currentId}

            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteTour(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];
  const openDeleteTour = (id) => {
    setAdminId(id);
    setOpenDeleteDialog(true);
  };

  const onFinishAdmin = (values) => {
    values.avatar = imageUrl;
    if (adminId != 0) {
      adminService.adminApi.updateAdmin(adminId, values).then((res) => {
        notification.success({ message: "Update admin success" });
        onCloseModalAdmin();
        getAllAdmin();
      });
    } else {
      adminService.adminApi.addAdmin(values).then((res) => {
        notification.success({ message: "Create admin success" });
        onCloseModalAdmin();
        getAllAdmin();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChange = async (info) => {
    if (!invalidImage) {
      if (info.file.status === 'uploading') {
        setLoading(true);
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        // getBase64(info.file.originFileObj, (url) => {
        //   setLoading(false);
        //   setImageUrl(url);
        // });
        console.log(123,info);
        setLoading(false);
        setImageUrl(info.file.response.data.url);
      }
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  let _contentState = ContentState.createFromText("Sample content state");
  const raw = convertToRaw(_contentState);
  const [contentState, setContentState] = useState(raw);
  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Quản Trị Viên
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateAdmin(true);
              console.log(221212);
              getRole();
            }}
          >
            Thêm Quản Trị Viên
          </Button>
        }
      >
        <Table columns={columnsTour} dataSource={listAdmin} bordered />
        <Modal
          title={adminId != 0 ? "Cập Nhật Quản Trị Viên" : "Thêm Quản Trị Viên"}
          visible={isShowUpdateAdmin}
          onCancel={() => {
            onCloseModalAdmin();
            setAdminId(0);
            setFileList([]);
            form.setFieldsValue({ title: "" });
          }}
          // width="65%"
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalAdmin();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            multiple={true}
            action={BASE_IMAGE_URL + "/api/upload"}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            // fileList={fileList}
          >
            {/* {uploadButton} */}
            {imageUrl ? <img src={BASE_IMAGE_URL+imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}

          </Upload>
          {/* //// */}
          <Form {...layout} form={form} name="CU-tour" onFinish={onFinishAdmin}>
            <Form.Item
              name="userName"
              label="Tên tài khoản"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, type: "email" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item name="roleId" label="Role" rules={[{ required: true }]}>
              <Select>
                {listRole?.map((x) => (
                  <Option value={x.id} key={x.id}>
                    {x.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {
              adminId!=0 ?
              <Divider plain style={{color: "darkgray"}}>
              Để trống phần bên dưới nếu bạn không thay đổi mật khẩu
            </Divider>
              :""
            }

            <Form.Item
              name="password"
              label="Mật khẩu"
              rules={[{ required: adminId!=0 ? false:true }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Xác nhận mật khẩu"
              rules={[
                { required: adminId!=0 ? false:true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
              dependencies={["password"]}
            >
              <Input.Password />
            </Form.Item>
          </Form>
          {/* //// */}
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteAdmin}
        onCancel={() => {
          setAdminId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa quản trị viên này`}
      >
        Bạn có chắc muốn xóa quản trị viên này?
      </Modal>
    </>
  );
}
